import React, { useEffect, useState } from 'react'

import server from 'server/serverController2'
import useForm from 'hooks/form/useForm'
import { RequireRule, CantContainWhitespace, CanNumberOnly } from 'utils/constants'

import Presenter from 'components/presenters/campaign/AccountFormModal'
import AnimatedWindow from 'components/containers/common/AnimatedWindow'
import AnimatedWindowHeader from 'components/presenters/header/AnimatedWindowHeader'
import { PrivacyConsent } from 'components/presenters/campaign/PrivacyConsent'
import { useSelector } from 'react-redux'

export default function AccountFormModal({ visible, onClose, onAccountFormModalCallback }) {
  const bankAccountInfo = useSelector((state) => {
    return state.bankAccountInfo
  })

  const {
    values: { accountNumber, accountHolderName },
    errors,
    onChange,
    isValid,
    updated,
    handleAddError,
    handleErrorTrigger,
    handleResetInput,
    handleSetValue,
  } = useForm(
    {
      accountNumber: '',
      accountHolderName: '',
    },
    {
      accountNumber: [
        RequireRule('* 계좌번호를 입력해 주세요'),
        CantContainWhitespace('* 공백 없이 입력해 주세요'),
        CanNumberOnly('* 숫자만 입력해 주세요'),
      ],
      accountHolderName: [
        RequireRule('* 이름(예금주)를 입력해 주세요'),
        CantContainWhitespace('* 공백 없이 입력해 주세요'),
      ],
    },
  )

  const [isPrivacyConsent, setIsPrivacyConsent] = useState(false)
  const [privacyConsentError, setPrivacyConsentError] = useState(null)

  const [accountNumberVisible, setAccountNumberVisible] = useState(false)

  const [privacyConsentVisible, setPrivacyConsentVisible] = useState(false)

  const [initState, setInitState] = useState(false)

  const handlePrivacyConsent = (e) => {
    const { checked } = e.target
    if (!isPrivacyConsent) {
      setPrivacyConsentError(null)
    }
    setIsPrivacyConsent(checked)
  }

  const handleOpenPrivacyConsent = () => {
    setPrivacyConsentVisible(true)
  }

  const handleCatchError = () => {
    handleErrorTrigger()
    if (!isPrivacyConsent) setPrivacyConsentError('* 약관내용에 동의해주세요')
  }

  const handleSubmit = async (e) => {
    try {
      e.preventDefault()

      const body = {
        bank_code: 'SHINHAN',
        account_number: accountNumber.replace(/[^0-9]*/g, ''),
        account_holder_name: accountHolderName,
      }
      const response = await server.postRequestData('users/bank/account', body)

      if (response?.success !== 1) {
        const errData = response.error.res_data
        throw errData.detail_code
      }

      handleResetInput()
      onAccountFormModalCallback()
      if (onClose) onClose()
    } catch (err) {
      if (err === 'BANK_ACCOUNT_NUMBER_ALREADY_EXIST') {
        handleAddError('accountNumber', '이미 등록된 계좌번호입니다.')
      }
    }
  }

  const handleModalClose = () => {
    setInitState(true)
    if (onClose) onClose()
  }

  const handleToggleAccountNumber = () => {
    setAccountNumberVisible((prevState) => !prevState)
  }

  useEffect(() => {
    if (initState) {
      handleResetInput()
      setPrivacyConsentError(null)
      setIsPrivacyConsent(false)
      setInitState(false)
    }
  }, [initState])

  useEffect(() => {
    handleSetValue({
      accountNumber: bankAccountInfo.account_number,
      accountHolderName: bankAccountInfo.account_holder_name,
    })
  }, [bankAccountInfo])

  if (!visible) return null
  return (
    <>
      <Presenter
        accountHolderName={accountHolderName}
        accountNumber={accountNumber}
        errors={errors}
        privacyConsentError={privacyConsentError}
        updated={updated}
        isPrivacyConsent={isPrivacyConsent}
        onSubmit={!isValid || !isPrivacyConsent ? handleCatchError : handleSubmit}
        onChange={onChange}
        onClose={handleModalClose}
        onPrivacyConsent={handlePrivacyConsent}
        onOpenPrivacyConsent={handleOpenPrivacyConsent}
        onToggleAccountNumberVisibility={handleToggleAccountNumber}
        accountNumberVisible={accountNumberVisible}
      />
      <AnimatedWindow windowOn={privacyConsentVisible} setWindowOn={setPrivacyConsentVisible}>
        <AnimatedWindowHeader
          title={'개인정보 제3자 제공'}
          onBackBtn={() => {
            window.history.back()
            setPrivacyConsentVisible(false)
          }}
        />
        <PrivacyConsent />
      </AnimatedWindow>
    </>
  )
}
